import { render, staticRenderFns } from "./gifts.vue?vue&type=template&id=291af13a&"
import script from "./gifts.vue?vue&type=script&lang=js&"
export * from "./gifts.vue?vue&type=script&lang=js&"
import style0 from "./gifts.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {GiftsSection: require('/opt/build/repo/storefront/components/legacy/gifts/gifts-section.vue').default,SgImg: require('/opt/build/repo/storefront/components/legacy/global/sg-img.vue').default,SgLink: require('/opt/build/repo/storefront/components/legacy/global/sg-link.vue').default,GiftsVoucher: require('/opt/build/repo/storefront/components/legacy/gifts/gifts-voucher.vue').default})
